module.exports = __webpack_public_path__ + "assets/img/driver-btn-8059d134.png";